import { render, staticRenderFns } from "./VerificationBadgesCreatePage.vue?vue&type=template&id=27b9b3be&scoped=true"
import script from "./VerificationBadgesCreatePage.vue?vue&type=script&lang=js"
export * from "./VerificationBadgesCreatePage.vue?vue&type=script&lang=js"
import style0 from "./VerificationBadgesCreatePage.vue?vue&type=style&index=0&id=27b9b3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9b3be",
  null
  
)

export default component.exports